import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

const ReportDropdown: React.FC = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOrderHistoryClick = () => {
    setOpen(false);
    navigate("/order-history");
  };

  return (
    <div className="report-dropdown" ref={dropdownRef}>
      <button
        type="button"
        className="report-dropdown-trigger"
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="report-label">Report</span>
        <i className={`ri-arrow-down-s-line report-chevron ${open ? "open" : ""}`} />
      </button>

      {open && (
        <div className="report-dropdown-menu">
          <button type="button" className="report-dropdown-item" onClick={handleOrderHistoryClick}>
            Order History
          </button>
        </div>
      )}
    </div>
  );
};

export default ReportDropdown;

